readEscapedUnicodeFixedWidth